import gql from 'graphql-tag';

export const CREATE_ORDER = gql`
    mutation OrderMutation(
        $slug: String!
        $order: InsertOrderInput
        $orderId: String
    ) {
        createStripeSession(slug: $slug, order: $order, orderId: $orderId) {
            stripeSessionId
        }
    }
`;
